var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.485,
    height: 16.889,
    viewBox: "0 0 17.485 16.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-1896800",
    transform: "translate(-48.898 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27668",
    "data-name": "Path 27668",
    d: "M224.576,0a3.737,3.737,0,0,1,3.736,3.736V6.187a3.751,3.751,0,1,1-7.5,0V3.736A3.744,3.744,0,0,1,224.576,0Z",
    transform: "translate(-166.921)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27669",
    "data-name": "Path 27669",
    d: "M48.9,397.082H66.383v-.926c0-1.614-5.32-3.945-6.665-3.945H55.563c-1.345,0-6.665,2.331-6.665,3.945Z",
    transform: "translate(0 -380.822)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163657",
    "data-name": "Group 163657",
    transform: "translate(48.905 16.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27670",
    "data-name": "Path 27670",
    d: "M.343-3.708.326-3.7l-.017,0a.06.06,0,0,1-.043-.015A.055.055,0,0,1,.25-3.756.053.053,0,0,1,.266-3.8a.059.059,0,0,1,.043-.015l.017,0L.343-3.8v.022L.327-3.789l-.016,0a.03.03,0,0,0-.024.01.038.038,0,0,0-.009.026.039.039,0,0,0,.009.027.03.03,0,0,0,.024.01l.016,0L.343-3.73Z",
    transform: "translate(-0.25 3.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163658",
    "data-name": "Group 163658",
    transform: "translate(49.02 16.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27671",
    "data-name": "Path 27671",
    d: "M.5-2.851l-.007,0H.484a.019.019,0,0,0-.015.007.027.027,0,0,0-.005.018v.038H.437v-.082H.463v.014a.032.032,0,0,1,.011-.012.033.033,0,0,1,.016,0H.5Z",
    transform: "translate(-0.437 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163659",
    "data-name": "Group 163659",
    transform: "translate(49.088 16.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27672",
    "data-name": "Path 27672",
    d: "M.306-2.832v.007H.246a.019.019,0,0,0,.006.014.025.025,0,0,0,.016,0l.017,0L.3-2.816v.02l-.019.005-.019,0A.049.049,0,0,1,.231-2.8a.041.041,0,0,1-.012-.032.041.041,0,0,1,.012-.031.048.048,0,0,1,.034-.011.04.04,0,0,1,.03.012.041.041,0,0,1,.012.031ZM.28-2.841a.016.016,0,0,0,0-.012.014.014,0,0,0-.011,0,.018.018,0,0,0-.013,0,.02.02,0,0,0-.006.012Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163660",
    "data-name": "Group 163660",
    transform: "translate(49.189 16.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27673",
    "data-name": "Path 27673",
    d: "M.261-2.828a.022.022,0,0,0-.012,0,.009.009,0,0,0,0,.008.009.009,0,0,0,0,.008.015.015,0,0,0,.01,0,.017.017,0,0,0,.012,0,.019.019,0,0,0,0-.013v0Zm.04-.01v.047H.275V-2.8a.032.032,0,0,1-.012.011.037.037,0,0,1-.016,0A.03.03,0,0,1,.226-2.8a.026.026,0,0,1-.008-.02.023.023,0,0,1,.01-.021A.055.055,0,0,1,.26-2.844H.275v0a.009.009,0,0,0,0-.009.028.028,0,0,0-.015,0l-.016,0-.013,0v-.02l.017,0H.26a.047.047,0,0,1,.032.009.036.036,0,0,1,.01.028Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163661",
    "data-name": "Group 163661",
    transform: "translate(49.285 16.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27674",
    "data-name": "Path 27674",
    d: "M.1-3.609v.023H.129v.019H.1v.035a.01.01,0,0,0,0,.008l.009,0H.126V-3.5H.1a.03.03,0,0,1-.022-.006.03.03,0,0,1-.006-.022v-.035H.062v-.019H.076v-.023Z",
    transform: "translate(-0.062 3.609)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163662",
    "data-name": "Group 163662",
    transform: "translate(49.361 16.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27675",
    "data-name": "Path 27675",
    d: "M.306-2.832v.007H.246a.019.019,0,0,0,.006.014.025.025,0,0,0,.016,0l.017,0L.3-2.816v.02l-.019.005-.019,0A.049.049,0,0,1,.231-2.8a.041.041,0,0,1-.012-.032.041.041,0,0,1,.012-.031.048.048,0,0,1,.034-.011.04.04,0,0,1,.03.012.041.041,0,0,1,.012.031ZM.28-2.841a.016.016,0,0,0,0-.012.014.014,0,0,0-.011,0,.018.018,0,0,0-.013,0,.02.02,0,0,0-.006.012Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163663",
    "data-name": "Group 163663",
    transform: "translate(49.463 16.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27676",
    "data-name": "Path 27676",
    d: "M.3-3.863v-.044H.322v.113H.3V-3.8a.039.039,0,0,1-.012.011.035.035,0,0,1-.015,0A.031.031,0,0,1,.244-3.8a.049.049,0,0,1-.01-.031.047.047,0,0,1,.01-.03.031.031,0,0,1,.025-.012.029.029,0,0,1,.015,0,.035.035,0,0,1,.012.01ZM.278-3.81a.014.014,0,0,0,.013-.006.031.031,0,0,0,0-.018.029.029,0,0,0,0-.018.015.015,0,0,0-.013-.006.015.015,0,0,0-.013.006.029.029,0,0,0,0,.018.03.03,0,0,0,0,.018A.015.015,0,0,0,.278-3.81Z",
    transform: "translate(-0.234 3.906)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163664",
    "data-name": "Group 163664",
    transform: "translate(49.628 16.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27677",
    "data-name": "Path 27677",
    d: "M.481-3.81a.014.014,0,0,0,.013-.006.031.031,0,0,0,0-.018.029.029,0,0,0,0-.018.015.015,0,0,0-.013-.006.015.015,0,0,0-.013.006.028.028,0,0,0,0,.017.03.03,0,0,0,0,.018A.015.015,0,0,0,.481-3.81ZM.463-3.863a.036.036,0,0,1,.012-.01.033.033,0,0,1,.015,0,.03.03,0,0,1,.024.012.046.046,0,0,1,.01.03.048.048,0,0,1-.01.031.03.03,0,0,1-.024.012.037.037,0,0,1-.015,0A.038.038,0,0,1,.463-3.8v.012H.438v-.113H.463Z",
    transform: "translate(-0.438 3.906)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163665",
    "data-name": "Group 163665",
    transform: "translate(49.724 16.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27678",
    "data-name": "Path 27678",
    d: "M.063-2.812H.089l.022.055.019-.055H.156l-.034.089A.046.046,0,0,1,.109-2.7.028.028,0,0,1,.091-2.7H.076v-.017H.084a.015.015,0,0,0,.01,0,.013.013,0,0,0,0-.007v0Z",
    transform: "translate(-0.063 2.813)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163666",
    "data-name": "Group 163666",
    transform: "translate(49.873 16.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27679",
    "data-name": "Path 27679",
    d: "M.031-3.75h.1v.021H.1v.088H.067v-.088H.031Z",
    transform: "translate(-0.031 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163667",
    "data-name": "Group 163667",
    transform: "translate(49.975 16.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27680",
    "data-name": "Path 27680",
    d: "M.11-3.661H.066l-.007.02H.031l.04-.109H.1l.04.109H.117Zm-.037-.02H.1L.088-3.725Z",
    transform: "translate(-0.031 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163668",
    "data-name": "Group 163668",
    transform: "translate(50.097 16.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27681",
    "data-name": "Path 27681",
    d: "M.309-3.7h0a.058.058,0,0,1-.042-.015A.056.056,0,0,1,.25-3.756.056.056,0,0,1,.265-3.8a.056.056,0,0,1,.041-.015A.054.054,0,0,1,.347-3.8a.055.055,0,0,1,.015.041.062.062,0,0,1-.008.032.049.049,0,0,1-.023.02l.022.024H.327Zm0-.092a.024.024,0,0,0-.02.01.044.044,0,0,0-.007.026.046.046,0,0,0,.007.027.024.024,0,0,0,.02.009.023.023,0,0,0,.02-.01.044.044,0,0,0,.007-.027.042.042,0,0,0-.007-.026A.023.023,0,0,0,.306-3.792Z",
    transform: "translate(-0.25 3.813)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163669",
    "data-name": "Group 163669",
    transform: "translate(50.23 16.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27682",
    "data-name": "Path 27682",
    d: "M.509-3.7a.019.019,0,0,0,.013,0,.015.015,0,0,0,0-.011.014.014,0,0,0,0-.01.02.02,0,0,0-.013,0H.5V-3.7ZM.5-3.682v.041H.469V-3.75H.512a.054.054,0,0,1,.031.007.026.026,0,0,1,.01.023A.029.029,0,0,1,.548-3.7a.029.029,0,0,1-.015.01.022.022,0,0,1,.01.006.055.055,0,0,1,.009.014l.015.031H.537L.524-3.668a.028.028,0,0,0-.008-.011.018.018,0,0,0-.011,0Z",
    transform: "translate(-0.469 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163670",
    "data-name": "Group 163670",
    transform: "translate(50.345 16.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27683",
    "data-name": "Path 27683",
    d: "M.469-3.75H.5v.109H.469Z",
    transform: "translate(-0.469 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163671",
    "data-name": "Group 163671",
    transform: "translate(50.401 16.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27684",
    "data-name": "Path 27684",
    d: "M.512-3.708a.015.015,0,0,0,.01,0,.011.011,0,0,0,0-.009.01.01,0,0,0,0-.009.014.014,0,0,0-.01,0H.5v.023Zm0,.048a.018.018,0,0,0,.013,0,.013.013,0,0,0,0-.011.013.013,0,0,0,0-.01.019.019,0,0,0-.013,0H.5v.029ZM.54-3.7a.024.024,0,0,1,.014.01.03.03,0,0,1,0,.017.027.027,0,0,1-.011.024.054.054,0,0,1-.032.008H.469V-3.75H.511a.06.06,0,0,1,.033.007.025.025,0,0,1,.01.022.023.023,0,0,1,0,.014A.022.022,0,0,1,.54-3.7Z",
    transform: "translate(-0.469 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163672",
    "data-name": "Group 163672",
    transform: "translate(50.567 16.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27685",
    "data-name": "Path 27685",
    d: "M.469-3.75H.5v.109H.469Z",
    transform: "translate(-0.469 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163673",
    "data-name": "Group 163673",
    transform: "translate(50.616 16.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27686",
    "data-name": "Path 27686",
    d: "M.343-3.708.326-3.7l-.017,0a.06.06,0,0,1-.043-.015A.055.055,0,0,1,.25-3.756.053.053,0,0,1,.266-3.8a.059.059,0,0,1,.043-.015l.017,0L.343-3.8v.022L.327-3.789l-.016,0a.03.03,0,0,0-.024.01.038.038,0,0,0-.009.026.039.039,0,0,0,.009.027.03.03,0,0,0,.024.01l.016,0L.343-3.73Z",
    transform: "translate(-0.25 3.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163674",
    "data-name": "Group 163674",
    transform: "translate(50.725 16.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27687",
    "data-name": "Path 27687",
    d: "M.306-3.792a.024.024,0,0,0-.02.01.044.044,0,0,0-.007.026.045.045,0,0,0,.007.027.024.024,0,0,0,.02.01.023.023,0,0,0,.02-.01.044.044,0,0,0,.007-.027.042.042,0,0,0-.007-.026A.023.023,0,0,0,.306-3.792Zm0-.02A.054.054,0,0,1,.347-3.8a.056.056,0,0,1,.015.041.057.057,0,0,1-.015.042A.054.054,0,0,1,.306-3.7a.056.056,0,0,1-.041-.015A.057.057,0,0,1,.25-3.756.056.056,0,0,1,.265-3.8.056.056,0,0,1,.306-3.813Z",
    transform: "translate(-0.25 3.813)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163675",
    "data-name": "Group 163675",
    transform: "translate(50.859 16.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27688",
    "data-name": "Path 27688",
    d: "M.469-3.75H.5l.04.075V-3.75H.566v.109H.535L.5-3.716v.075H.469Z",
    transform: "translate(-0.469 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163676",
    "data-name": "Group 163676",
    transform: "translate(48.901 16.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27689",
    "data-name": "Path 27689",
    d: "M.157-3.906v.017H.143a.011.011,0,0,0-.008,0,.008.008,0,0,0,0,.007v.005H.155v.019H.133v.063H.107v-.063H.094v-.019H.107V-3.88A.025.025,0,0,1,.114-3.9a.036.036,0,0,1,.023-.006Z",
    transform: "translate(-0.094 3.906)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163677",
    "data-name": "Group 163677",
    transform: "translate(48.976 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27690",
    "data-name": "Path 27690",
    d: "M.5-2.851l-.007,0H.484a.019.019,0,0,0-.015.007.027.027,0,0,0-.005.018v.038H.437v-.082H.463v.014a.032.032,0,0,1,.011-.012.033.033,0,0,1,.016,0H.5Z",
    transform: "translate(-0.437 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163678",
    "data-name": "Group 163678",
    transform: "translate(49.043 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27691",
    "data-name": "Path 27691",
    d: "M.264-2.856a.015.015,0,0,0-.013.006.029.029,0,0,0,0,.018.03.03,0,0,0,0,.018.015.015,0,0,0,.013.006.015.015,0,0,0,.013-.006.031.031,0,0,0,0-.018.029.029,0,0,0,0-.018A.015.015,0,0,0,.264-2.856Zm0-.019A.046.046,0,0,1,.3-2.864a.042.042,0,0,1,.012.031A.042.042,0,0,1,.3-2.8a.046.046,0,0,1-.033.011A.047.047,0,0,1,.231-2.8a.042.042,0,0,1-.012-.032.041.041,0,0,1,.012-.031A.047.047,0,0,1,.264-2.875Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163679",
    "data-name": "Group 163679",
    transform: "translate(49.152 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27692",
    "data-name": "Path 27692",
    d: "M.5-2.86a.033.033,0,0,1,.012-.011.029.029,0,0,1,.015,0,.027.027,0,0,1,.021.009.037.037,0,0,1,.008.025v.05H.527v-.048a.021.021,0,0,0,0-.012.008.008,0,0,0-.008,0A.013.013,0,0,0,.5-2.849a.031.031,0,0,0,0,.018v.04H.474v-.043a.041.041,0,0,0,0-.017.009.009,0,0,0-.008,0,.013.013,0,0,0-.012.006.03.03,0,0,0,0,.017v.04H.422v-.082H.448v.012a.033.033,0,0,1,.011-.01.028.028,0,0,1,.014,0,.026.026,0,0,1,.015,0A.025.025,0,0,1,.5-2.86Z",
    transform: "translate(-0.422 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163680",
    "data-name": "Group 163680",
    transform: "translate(49.349 16.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27693",
    "data-name": "Path 27693",
    d: "M.1-3.609v.023H.129v.019H.1v.035a.01.01,0,0,0,0,.008l.009,0H.126V-3.5H.1a.03.03,0,0,1-.022-.006.03.03,0,0,1-.006-.022v-.035H.062v-.019H.076v-.023Z",
    transform: "translate(-0.062 3.609)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163681",
    "data-name": "Group 163681",
    transform: "translate(49.431 16.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27694",
    "data-name": "Path 27694",
    d: "M.52-3.843v.05H.493v-.038c0-.007,0-.012,0-.015a.013.013,0,0,0,0-.006l0,0H.481a.016.016,0,0,0-.013.006.029.029,0,0,0,0,.017v.04H.437v-.113H.463v.044a.039.039,0,0,1,.012-.01.032.032,0,0,1,.015,0,.027.027,0,0,1,.021.009.037.037,0,0,1,.008.025Z",
    transform: "translate(-0.437 3.906)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163682",
    "data-name": "Group 163682",
    transform: "translate(49.531 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27695",
    "data-name": "Path 27695",
    d: "M.306-2.832v.007H.246a.019.019,0,0,0,.006.014.025.025,0,0,0,.016,0l.017,0L.3-2.816v.02l-.019.005-.019,0A.049.049,0,0,1,.231-2.8a.041.041,0,0,1-.012-.032.041.041,0,0,1,.012-.031.048.048,0,0,1,.034-.011.04.04,0,0,1,.03.012.041.041,0,0,1,.012.031ZM.28-2.841a.016.016,0,0,0,0-.012.014.014,0,0,0-.011,0,.018.018,0,0,0-.013,0,.02.02,0,0,0-.006.012Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163683",
    "data-name": "Group 163683",
    transform: "translate(49.692 16.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27696",
    "data-name": "Path 27696",
    d: "M.469-3.75H.5l.04.075V-3.75H.566v.109H.535L.5-3.716v.075H.469Z",
    transform: "translate(-0.469 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163684",
    "data-name": "Group 163684",
    transform: "translate(49.81 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27697",
    "data-name": "Path 27697",
    d: "M.264-2.856a.015.015,0,0,0-.013.006.029.029,0,0,0,0,.018.03.03,0,0,0,0,.018.015.015,0,0,0,.013.006.015.015,0,0,0,.013-.006.031.031,0,0,0,0-.018.029.029,0,0,0,0-.018A.015.015,0,0,0,.264-2.856Zm0-.019A.046.046,0,0,1,.3-2.864a.042.042,0,0,1,.012.031A.042.042,0,0,1,.3-2.8a.046.046,0,0,1-.033.011A.047.047,0,0,1,.231-2.8a.042.042,0,0,1-.012-.032.041.041,0,0,1,.012-.031A.047.047,0,0,1,.264-2.875Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163685",
    "data-name": "Group 163685",
    transform: "translate(49.918 16.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27698",
    "data-name": "Path 27698",
    d: "M.406-2.763v-.05H.433V-2.8s0,.01,0,.017v.013c0,.007,0,.012,0,.015a.011.011,0,0,0,0,.006l0,0H.445a.015.015,0,0,0,.013-.006.03.03,0,0,0,0-.017v-.04H.488v.082H.462v-.012a.042.042,0,0,1-.013.011.033.033,0,0,1-.015,0,.026.026,0,0,1-.021-.009.039.039,0,0,1-.007-.025Z",
    transform: "translate(-0.406 2.813)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163686",
    "data-name": "Group 163686",
    transform: "translate(50.025 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27699",
    "data-name": "Path 27699",
    d: "M.52-2.841v.05H.493V-2.83c0-.007,0-.012,0-.015a.013.013,0,0,0,0-.006l0,0H.481a.016.016,0,0,0-.013.006.029.029,0,0,0,0,.017v.04H.437v-.082H.463v.012a.039.039,0,0,1,.012-.01.032.032,0,0,1,.015,0,.027.027,0,0,1,.021.009.037.037,0,0,1,.008.025Z",
    transform: "translate(-0.437 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163687",
    "data-name": "Group 163687",
    transform: "translate(50.184 16.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27700",
    "data-name": "Path 27700",
    d: "M.469-3.75H.515a.047.047,0,0,1,.032.01.032.032,0,0,1,.011.026.033.033,0,0,1-.011.027.048.048,0,0,1-.032.009H.5v.038H.469ZM.5-3.73v.03H.512a.018.018,0,0,0,.013,0,.015.015,0,0,0,0-.011.014.014,0,0,0,0-.011.018.018,0,0,0-.013,0Z",
    transform: "translate(-0.469 3.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163688",
    "data-name": "Group 163688",
    transform: "translate(50.293 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27701",
    "data-name": "Path 27701",
    d: "M.5-2.851l-.007,0H.484a.019.019,0,0,0-.015.007.027.027,0,0,0-.005.018v.038H.437v-.082H.463v.014a.032.032,0,0,1,.011-.012.033.033,0,0,1,.016,0H.5Z",
    transform: "translate(-0.437 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163689",
    "data-name": "Group 163689",
    transform: "translate(50.36 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27702",
    "data-name": "Path 27702",
    d: "M.264-2.856a.015.015,0,0,0-.013.006.029.029,0,0,0,0,.018.03.03,0,0,0,0,.018.015.015,0,0,0,.013.006.015.015,0,0,0,.013-.006.031.031,0,0,0,0-.018.029.029,0,0,0,0-.018A.015.015,0,0,0,.264-2.856Zm0-.019A.046.046,0,0,1,.3-2.864a.042.042,0,0,1,.012.031A.042.042,0,0,1,.3-2.8a.046.046,0,0,1-.033.011A.047.047,0,0,1,.231-2.8a.042.042,0,0,1-.012-.032.041.041,0,0,1,.012-.031A.047.047,0,0,1,.264-2.875Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163690",
    "data-name": "Group 163690",
    transform: "translate(50.452 16.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27703",
    "data-name": "Path 27703",
    d: "M-.154-3.875h.026v.08a.035.035,0,0,1-.008.025.029.029,0,0,1-.022.009H-.172v-.017h0a.012.012,0,0,0,.01,0,.019.019,0,0,0,0-.013Zm0-.032h.026v.021H-.154Z",
    transform: "translate(0.172 3.906)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163691",
    "data-name": "Group 163691",
    transform: "translate(50.514 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27704",
    "data-name": "Path 27704",
    d: "M.306-2.832v.007H.246a.019.019,0,0,0,.006.014.025.025,0,0,0,.016,0l.017,0L.3-2.816v.02l-.019.005-.019,0A.049.049,0,0,1,.231-2.8a.041.041,0,0,1-.012-.032.041.041,0,0,1,.012-.031.048.048,0,0,1,.034-.011.04.04,0,0,1,.03.012.041.041,0,0,1,.012.031ZM.28-2.841a.016.016,0,0,0,0-.012.014.014,0,0,0-.011,0,.018.018,0,0,0-.013,0,.02.02,0,0,0-.006.012Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163692",
    "data-name": "Group 163692",
    transform: "translate(50.616 16.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27705",
    "data-name": "Path 27705",
    d: "M.291-2.871v.021L.28-2.855l-.011,0a.023.023,0,0,0-.017.006.025.025,0,0,0-.006.018.026.026,0,0,0,.006.018.023.023,0,0,0,.017.006l.011,0,.01-.005v.021l-.012,0H.266A.05.05,0,0,1,.231-2.8a.041.041,0,0,1-.012-.032.041.041,0,0,1,.012-.031.051.051,0,0,1,.035-.011H.278l.013,0Z",
    transform: "translate(-0.219 2.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163693",
    "data-name": "Group 163693",
    transform: "translate(50.7 16.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27706",
    "data-name": "Path 27706",
    d: "M.1-3.609v.023H.129v.019H.1v.035a.01.01,0,0,0,0,.008l.009,0H.126V-3.5H.1a.03.03,0,0,1-.022-.006.03.03,0,0,1-.006-.022v-.035H.062v-.019H.076v-.023Z",
    transform: "translate(-0.062 3.609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a46a1388f31d0c531fa3c8b30df23b5a.svg";
export { ForwardRef as ReactComponent };